import * as React from "react";
import type { SVGProps } from "react";
const SvgCurrencyCoinBitcoin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.4 8.02h5.385a2.02 2.02 0 1 1 0 4.038m0 0a2.02 2.02 0 0 1 0 4.038H8.4m5.385-4.038H9.746m0-4.039v8.077M10.42 6v2.02M13.112 6v2.02m-2.693 8.076v2.02m2.693-2.02v2.02M21.6 12a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 1 1 19.2 0"
    />
  </svg>
);
export default SvgCurrencyCoinBitcoin;
